import script from "./QuestionnaireWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuestionnaireWidget.vue?vue&type=script&lang=ts&setup=true"

import "./QuestionnaireWidget.vue?vue&type=style&index=0&id=04421fc2&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04421fc2"]])

export default __exports__